import AIMEOS from './aimeos-constants'
import jsonapi from './jsonapi-constants'
import BACKORDER from './backorder-constants'
import ORDERTRACKING from './ordertracking-constants'
import CTA from './cta-constants'
import CREDITLIMIT from './creditlimit-constants'
import LINKTILES from './linktiles-constants'
import CONTACTTILE from './contacttile-constants'
import URL_PARAMS from './url-params-constants'

export default {
  ...jsonapi,
  URL_PARAMS,
  BACKORDER,
  ORDERTRACKING,
  CTA,
  CREDITLIMIT,
  LINKTILES,
  CONTACTTILE,
  DATA: 'data',
  TYPE: 'type',
  ID: 'id',
  RELATIONSHIPS: 'relationships',
  ATTRIBUTES: 'attributes',
  PAGE_ID: 'pageId',
  BADGE_DATE: 'badge_date',
  LINK_TILES: 'link_tiles',
  ATTRIBUTE: {
    TITLE: 'title',
    HEADER: 'header',
    TEASER: 'teaser',
    READ: 'read',
    DATE: 'date',
    HEADERLAYOUT: 'headerLayout',
    HEADERLAYOUT_VALUE_DEFAULT: '3',
    HEADER_ALIGNMENT: 'headerAlignment',
    HEADER_ALIGNMENT_VALUE_DEFAULT: 'left',
    COLUMNHEADER: 'column_header',
    COLUMNHEADERLAYOUT_VALUE_DEFAULT: '2',
  },
  ADDRESSES: {
    SAP_ADDRESS_ID: 'attributes.sap_address_id',
  },
  BRANDS: 'brands',
  BRAND: {
    TYPE: 'brand',
  },
  ELEMENTS: 'elements',
  ELEMENT: {
    TYPE: 'element',
    GROUP_SUFFIX: 'Group',
  },
  IMAGE: {
    KEY: 'image',
    TITLE: 'title',
    ALT: 'alternative',
    SRC: 'url',
    LINK: 'link',
    CAPTION: 'description',
    LIGHTBOX: 'lightBox',
  },
  ICON: {
    NAME: 'icon',
    TITLE: 'title',
    ATTRIBUTE: {
      COMPONENT: 'component',
    },
  },
  TITLE: 'title',
  CURRENT: 'current',
  URL: 'url',
  TARGET: 'target',
  PAGEURL: 'pageUrl',
  PAGE: 'page',
  GRID: {
    TYPE: 'grid',
    SIZE: 'grid/size',
    COLUMN: 'columns', // grid/column,
    ELEMENTS: 'columnitems', // grid/elements, elements
    GROUP: 'groupitems',
    ATTRIBUTE: {
      GROUP_HEADER: 'group_header',
      GROUP_SUBHEADER: 'group_subheader',
      COLUMN_CONTENT_ALTERNATIVE_ENABLED: 'column_content_alternative_enabled',
      SLIDER_TIME_INTERVAL: 'slider_time_interval',
      BACKGROUND_CLASSES: 'background-classes',
    },
  },
  HELP_GRID: {
    ELEMENTS: 'columnitems',
  },
  ACCORDION: {
    TYPE: 'accordion',
    ITEMS: 'columns',
    ELEMENTS: 'columnitems',
  },
  NAVIGATION: {
    ATTRIBUTE: {
      SHOW_TITLE_IN_MENU: 'showTitleInMenu',
      NAVIGATION_SECONDARY: 'navigation_secondary',
      AUTO_LINK_TO_FIRST_CHILD: 'auto_link_to_first_child',
      NAVIGATION_COMPONENT: 'component',
      NAVIGATION_LINK_TILES: 'link_tiles',
    },
    NAVIGATION_TYPE: 'navigation',
    TOP_TYPE: 'navigation/top',
    MINIMAL_TYPE: 'navigation/minimal',
    FOOTER_TYPE: 'navigation/footer',
    ITEM_TYPE: 'navigation/item',
    BUTTON_ITEM_TYPE: 'navigation/button_item',
    ICON_TYPE: 'navigation/icon_item',
    LANGUAGE_TYPE: 'navigation/language',
    ICON_TEXT_TYPE: 'navigation/icon_text_item',
    SEPARATOR_TYPE: 'navigation/separator_item',
    IMAGES_TYPE: 'navigation/images_item',
    CATEGORIES: 'navigation/category',
  },
  NEWS: {
    ITEM: 'news/item',
    CATEGORY: 'news/category',
    CE: 'news/ce',
  },
  MESSAGE: {
    MESSAGE: 'message',
    MESSAGES: 'messages',
    TOTAL: 'total',
    DATE: 'date',
    TITLE: 'title',
    BODY: 'body',
    FROM_EMAIL: 'fromemail',
    FROM_NAME: 'fromname',
    READ: 'read',
    UNREAD: 'unread',
    NEW: 'new',
    ARCHIVED: 'archived',
    PRIORITY: 'priority',
    UID: 'uid',
    TYPE: 'type',
    TICKET_ID: 'ticketid',
    TICKET_NUMBER: 'ticketnumber',
    TICKET_STATUS: 'ticketstatus',
    ARTICLES: 'articles',
    TYPES: {
      INFO: 'Info',
      MARKETING: 'Marketing',
      HUBSPOT: 'Hubspot',
    },
  },
  PRODUCTS: {
    TYPE: 'products',
    ATTRIBUTE: 'attribute',
    ITEM_SCOPES: 'itemScopes',
    PRICE: 'price',
    MEDIA: 'media',
  },
  META: {
    TYPE: 'meta',
    TOTAL: 'total',
    PAGINATION: 'pagination',
    ACTIVE_PAGE: 'activePage',
    TOTAL_ITEMS: 'totalItems',
    ITEMS_PER_PAGE: 'itemsPerPage',
  },
  USERS: {
    TYPE: 'users',
  },
  CATALOG: {
    TYPE: 'catalog',
  },
  AIMEOS,
  COMPARE: 'compare',
}
